import React from 'react';

const LandingPageContainer = ({ children, additionalclasses, id }) => {
    return (
        <div id={id} className={`lg:max-w-[1400px]  lg:px-[50px] m-auto px-[16px] lg:gap-[32px] ${additionalclasses}`}>
            {children}
        </div>
    );
};

export default LandingPageContainer;